import "slick-carousel";
import 'slick-carousel/slick/slick.css';
$(document).ready(function () {
    $('.garage-list-single').slick({
        infinite: false,
        mobileFirst: true,

        slidesToShow: 1.05,
        arrows: false,
        dots: true,
        customPaging: function (slider, i) {
            return '<span class="slick-bullet"></span>';
        },

        responsive: [
            {
                breakpoint: 768 - 1,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1240 - 1,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 1600 - 1,
                settings: {
                    slidesToShow: 4.2,
                    slidesToScroll: 4,
                    autoplay: false,
                },
            },

        ],
    });

});
